import { render, staticRenderFns } from "./CopyHTMLToClipboardComponent.vue?vue&type=template&id=51d1278a&"
import script from "./CopyHTMLToClipboardComponent.vue?vue&type=script&lang=ts&"
export * from "./CopyHTMLToClipboardComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51d1278a')) {
      api.createRecord('51d1278a', component.options)
    } else {
      api.reload('51d1278a', component.options)
    }
    module.hot.accept("./CopyHTMLToClipboardComponent.vue?vue&type=template&id=51d1278a&", function () {
      api.rerender('51d1278a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CopyToClipboard/CopyHTMLToClipboardComponent.vue"
export default component.exports